(function () {
    'use strict';

    angular
        .module('app.filterTypes')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'filtertypes',
                  config: {
                      abstract: true,
                      url: '/filtertypes',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.userType() == "0") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'filtertypes.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/filtertypes/list.html?v=' + opsIncludeVersion,
                    controller: 'FilterTypesListController',
                    controllerAs: 'vm',
                    title: 'Filter Types'
                }
            },
            {
             state: 'filtertypes.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/filterTypes/details.html?v=' + opsIncludeVersion,
                 controller: 'FilterTypeDetailController',
                 controllerAs: 'vm',
                 title: 'Filter Type',
                 settings: {}
             }
            }
          
        ];
    }
})();
